'use strict';

var isNode = typeof document === 'undefined';
if (!isNode) {
    var SuperAgent = require('superagent');
}

// Wraps a call to the API in a promise
// params:
//   store: Refux store
//   suppressAlert: set to true for front-end (no alert, no redirect to /logout)
export default function API(command, params, store, suppressAlert) {
    return new Promise(function(resolve, reject) {
        const query = {
            command: command,
            params: params
        };

        // Passed in from frontend.../rstore.js or backend.../Framework/API.js or moodboard.../Framework/API.js
        if (store) {
            const session = store.getState().session;
            if (session && session.uid) {       // supported by frontend rstore.js, backend Store.js, moodboard Store.js
                query.session = session.uid;
            }
        }
        
        SuperAgent.post(`//${Payload.release.api_host}`).set('Content-Type', 'application/json')
            .send(query)
            .withCredentials()    // send cookies, specifically PHPSESSID
            .then(response => {
                // if (response.type == 'text/html') {
                //     document.write(response.text);
                // }
                
                const r = ParseAPI(query, null, response);

                if (!r.ok) {
                    if (suppressAlert !== true && r.error != "You don't have permission to run the command Logout.") {
                        alert(r.error);
                    }
                    reject(Error(r.error));
                    // if (suppressAlert !== true && r.reject) {
                    //     document.location = '/logout';
                    // }
                } else {
                    resolve(r.res);
                }
            }, reject);
    });
}

function ParseAPI(query, err, res) {
    var r = null,
        exception = null;
    try {
        r = JSON.parse(res.text);
    } catch (exception) {
        if (typeof Raven !== 'undefined' && Raven) {
            var err_str = (err && err.response) ? `${err.response.statusCode}: ${err.response.statusText}` : '<no err>';
            var text_str = res ? res.text : '<no res>';
            Raven.captureException(exception, {
                extra: {
                    query: query,
                    err: err_str,
                    res: text_str,
            }});
        }
        if (typeof alert !== 'undefined') {
            // alert('An error occurred; this has been reported. Please try reloading the page.');
        } else {
            console.log('An error occurred; this has been reported. Please try reloading the page.');
            console.log(err_str, res.text);
        }
        return null;
    }
    return r;
};



// WEBPACK FOOTER //
// /home/eric/projects/com.strongproject/repos/platforms/common-js/framework/API.js